import React from 'react';
import { Link } from 'react-router-dom';
import AutomationSection from '../components/sections/AutomationSection';

const BusinessAutomation: React.FC = () => {
    return (
        <div>
            {/* Hero Section */}
            <section className="bg-primary py-20">
                <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center">
                        <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 font-inter">
                            Business Automation
                        </h1>
                        <p className="text-xl text-gray-100 mb-8 max-w-3xl mx-auto">
                            Streamline your business processes with intelligent automation solutions
                        </p>
                    </div>
                </div>
            </section>

            <AutomationSection />

            {/* CTA Section */}
            <section className="py-14 bg-white border-t border-gray-100 mt-10">
                <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 className="text-3xl md:text-4xl font-bold text-[#0B1538] mb-4">
                        Start Automating Your Business
                    </h2>
                    <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
                        See how much time and money you can save with our automation tools.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <Link
                            to="/contact"
                            className="px-8 py-4 bg-[#0B25E6] text-white rounded-lg hover:bg-blue-800  transition-colors text-lg font-semibold"
                        >
                            Get Started
                        </Link>
                        <Link
                            to="/contact"
                            className="px-8 py-4 text-white border-2 border-white rounded-lg hover:bg-blue-800 text-white transition-colors text-lg font-semibold"
                        >
                            Schedule Consultation
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default BusinessAutomation;
